import React, { useState, useEffect } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { post, postupload } from "../utils/helpers/http";
import Loader from "../Loader/Loader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import debounce from "lodash.debounce";
import { Link } from "react-router-dom";

const Drivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [statusFilter] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loader, setLoader] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteDriverId, setDeleteDriverId] = useState(null);
  // const [orderStatusOptions, setOrderStatusOptions] = useState([]);
  const [dataFound, setDataFound] = useState(true);

  useEffect(() => {
    fetchData();
    // fetchOrderStatusOptions();
  }, []);



  useEffect(() => {
    fetchData();
  }, [pageNo, pageSize]);

  const fetchData = async () => {
    setLoader(true);
    try {
      const body = {
        pageNo,
        pageSize,
        searchKeyword,
      };

      const response = await post("/Driver/DriverList", body);
      console.log("get driver list response....", response);
      if (response.data.data) {
        setDrivers(response.data.data.drivers);
        setTotalRecords(response.data.data.totalRecords);
        setDataFound(true);
        console.log("if driver list");
      } else {
        setDrivers([]);
        setTotalRecords(0);
        setDataFound(false);
        console.log("else driver list []");
      }
    } catch (error) {
      setDrivers([]);
      setTotalRecords(0);
      setDataFound(false);
    } finally {
      setLoader(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(totalRecords / pageSize)) {
      setPageNo(newPage);
    }
  };
  
  useEffect(() => {
    if (searchKeyword.length >= 3) {
      const debouncedSearch = debounce(() => {
        fetchData();
      }, 300);
      debouncedSearch();
      return () => {
        debouncedSearch.cancel();
      };
    } else if (searchKeyword === "") {
      setDrivers([]);
    }
  }, [searchKeyword, statusFilter, pageNo, pageSize]);

  const handleSearchChange = (e) => {
    console.log("e.target.value****", e.target.value)
    const value = e.target.value.trim();
    setSearchKeyword(value);
  };

  useEffect(() => {
    console.log("*****driver search keyword**", searchKeyword, searchKeyword.length)
    if (searchKeyword.length > 3) {
      setSearchKeyword(searchKeyword);
    } else if (searchKeyword.length === 0) {
      setSearchKeyword("");
      fetchData();
    }
  }, [searchKeyword]);


  const handleDeleteDriver = async (id) => {
    console.log("delete driver id *** ")
    setDeleteDriverId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirmation = async () => {
    try {
      let body = { id: deleteDriverId }
      const response = await post('/Driver/DeleteByDriverId', body);
      console.log("delete driver ****** ", response)

      fetchData(response.data.data.drivers);

      toast.success("Details deleted successfully");
    } catch (error) {
    } finally {
      setShowDeleteModal(false);
    }
  };
  
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  
  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setPageNo(1);
    fetchData(1, newSize);
  };

  const handleExport = async()=>{
    setLoader(true);
    try {
      let body = {
        pageNo: pageNo,
        pageSize: pageSize,
        searchKeyword: searchKeyword,
      }
      const response = await postupload('/Driver/ExportDriverToExcel', body, { //correct url for export driver
        responseType: 'arraybuffer',
      });
      if (response?.data) {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'DriverList.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } 
        else {  
        console.log("else customer list []");
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  }

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div class="lefth d-flex align-items-center justify-content-center flex-wrap">
                  <h1 class="page-title me-3">Driver(s)</h1>
                  <div class="headertabs ms-auto me-auto">
                    <Link
                      to="/manage-drivers"
                      className="active"
                      onClick={() => {
                        setSearchKeyword("");
                        setPageNo(1);
                      }}
                    >
                      All Drivers
                    </Link>
                    <Link
                      to="/last-location"
                      onClick={() => {
                        setSearchKeyword("");
                        setPageNo(1);
                      }}
                    >
                      Last known location
                    </Link>

                  </div>
                </div>
              </div>
              <div className="page-content">
                <div className="w-100" id="allDriversContent">
                  <div class="table-filters">
                    <div className="left_filters">
                      <div className="filterBox">
                        <label className="form-filter-label">Show</label>
                        <select
                          className="form-filter form-select"
                          onChange={handlePageSizeChange}
                          value={pageSize}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={20}>20</option>
                        </select>
                        <label className="ps-2">entries</label>
                      </div>
                    </div>
                    <div class="right_filters">
                    <button className="btn btn-primary tableBtnCss " onClick={handleExport}>Export</button>
                      {/* {/ status filter /} */}
                      {/* <div class="filtersearch me-3">
                        <label>Filter By Status:</label>
                        <select
                          class="form-control form-select"
                          value={statusFilter}
                          onChange={handleStatusFilterChange}
                        >
                          <option value="All">All</option>
                          {orderStatusOptions.map(option => (
                            <option key={option.id} value={option.id}>{option.status}</option>
                          ))}
                        </select>
                      </div> */}
                      <div class="searchBox">
                        <label>Search:</label>
                        <input
                          type="text"
                          class="form-filter"
                          placeholder="Search by Driver name, phone & email"
                          value={searchKeyword}
                          onChange={handleSearchChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="table-outerbox">
                    <table className="table">
                      <thead>
                        <tr>
                          <th width="20">SNo.</th>
                          <th>Driver Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Postcode</th>
                          <th>Driver License</th>
                          <th>Public Liablity Insurance</th>
                          <th>Indemnity Insurance</th>
                          <th>Action</th>
                        </tr>
                        <tr>
                          {!dataFound &&
                            <td colSpan="12" style={{ textAlign: "center", padding: "20px", fontSize: "large", fontWeight: "bold" }}>
                              No Data Found.
                            </td>}
                        </tr>
                      </thead>
                      <tbody>
                        {drivers.length ? drivers.map((driver, index) => (
                          <tr key={index}>
                            <td>{(pageNo - 1) * pageSize + index + 1}</td>
                            <td>
                              <div className="withImg">
                                <img
                                  src={require("../assets/images/user_1.jpg")}
                                  alt="user"
                                />
                                       {/* <img
                                  src={
                                    driver.profileImage
                                      ? driver.profileImage
                                      : require("../assets/images/user_1.jpg")
                                  }
                                  alt='user'
                                /> */}
                                <label>{driver.firstName} {driver.lastName}</label>
                              </div>
                            </td>
                            <td>{driver.email}</td>
                            <td>{driver.phoneNumber}</td>
                            <td>{driver.postCode}</td>
                            <td>
                              {!driver.driverLicenseFile ? "-" :
                                <div class="license_detailbox">
                                  <a href={driver.driverLicenseFile} target="_blank">{driver.firstName} {driver.lastName} Driver</a>
                                  <span>{formatDate(driver.driverLicenseExpiryDate)}</span>
                                </div>}
                            </td>
                            <td>
                              {!driver.publicLiabilityInsuranceFile ? "-" :
                                <div class="license_detailbox">
                                  <a href={driver.publicLiabilityInsuranceFile} target="_blank">{driver.firstName} {driver.lastName} Driver</a>
                                  <span>{formatDate(driver.publicLiabilityInsuranceExpiryDate)}</span>
                                </div>}
                            </td>
                            <td>
                              {!driver.indemnityInsuranceFile ? "-" :
                                <div class="license_detailbox">
                                  <a href={driver.indemnityInsuranceFile} target="_blank">{driver.firstName} {driver.lastName} Driver</a>
                                  <span>{formatDate(driver.indemnityInsuranceExpiryDate)}</span>
                                </div>}
                            </td>
                            <td>
                              <a
                                href="/"
                                className="actionbtn deleteAction"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleDeleteDriver(driver.id);
                                }}
                              >
                                <FontAwesomeIcon icon={faTrashCan} />
                              </a>
                            </td>
                          </tr>
                        )) : null}
                      </tbody>
                    </table>
                  </div>
                </div>

                {dataFound && (
                  <div className="table-pagination">
                    <div className="leftpart">
                      <span className="entriesdata">
                        Showing {Math.min((pageNo - 1) * pageSize + 1, totalRecords)} to{" "}
                        {Math.min(pageNo * pageSize, totalRecords)} of {totalRecords} entries
                      </span>
                    </div>
                    <div className="rightpart">
                      <div className="pagination_box">
                        <ul>
                          <li className="prev">
                            <button
                              onClick={() => handlePageChange(pageNo - 1)}
                              disabled={pageNo === 1}
                            >
                              <i className="fa-solid fa-chevron-left"></i> Previous
                            </button>
                          </li>
                          {[...Array(Math.ceil(totalRecords / pageSize)).keys()].map((page) => (
                            <li key={page} className={page + 1 === pageNo ? "current" : ""}>
                              <button onClick={() => handlePageChange(page + 1)}>
                                <span>{page + 1}</span>
                              </button>
                            </li>
                          ))}
                          <li className="next">
                            <button
                              onClick={() => handlePageChange(pageNo + 1)}
                              disabled={pageNo >= Math.ceil(totalRecords / pageSize)}
                            >
                              Next <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  className="w-100 locationDiv"
                  id="lastLocationContent"
                  style={{ display: "none" }}
                >
                  Map
                </div>
              </div>
            </div>
            {loader && <Loader />}
          </div>
          <ToastContainer />
          <Footer />
        </div>
      </div>
      {showDeleteModal && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Driver Confirmation</h5>
                <button type="button" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this driver?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleDeleteConfirmation}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Drivers;
